<template>
  <div>
    <v-layout column>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex pr-2 xs6>
            <w-schema :model="schema.profile.firstName">
              <v-text-field name="firstName" :label="schema.profile.firstName.$schema.title" @input="generateLogin" />
            </w-schema>
          </v-flex>

          <v-flex pl-2 xs6>
            <w-schema :model="schema.profile.lastName">
              <v-text-field name="lastName" :label="schema.profile.lastName.$schema.title" @input="generateLogin" />
            </w-schema>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12>
        <w-schema :model="schema.login">
          <v-text-field
            name="login"
            :label="schema.login.$schema.title"
            :readonly="edit"
            :hint="edit ? 'Nie można zmienić nazwy użytkownika' : 'Nazwa użytkownika używana do logowania do systemu'"
          />
        </w-schema>
      </v-flex>

      <v-flex v-if="official" xs12>
        <w-schema :model="schema.profile.companyName">
          <v-text-field
            name="companyName"
            :label="schema.profile.companyName.$schema.title"
            :disabled="schema.profile.type.$model === ProfileType.PARTNER"
          />
        </w-schema>
      </v-flex>

      <v-flex v-if="official" xs12>
        <w-schema :model="schema.profile.companyPosition">
          <v-text-field name="companyPosition" label="Stanowisko" />
        </w-schema>
      </v-flex>

      <v-flex v-if="!simple" class="date-picker" xs12>
        <datepicker :schema="schema.profile.birthDate" />
      </v-flex>

      <v-flex v-if="!simple" xs12>
        <w-schema :model="schema.profile.gender">
          <v-select label="Płeć *" item-text="text" item-value="value" :items="gender" />
        </w-schema>
      </v-flex>

      <v-flex v-if="!hideEmail" xs12>
        <w-schema :model="schema.profile.email">
          <v-text-field name="email" :label="schema.profile.email.$schema.title" />
        </w-schema>
      </v-flex>

      <v-flex v-if="!simple || official" xs12>
        <w-schema :model="schema.profile.phoneNumber">
          <v-text-field name="phoneNumber" label="Numer telefonu" />
        </w-schema>
      </v-flex>

      <teryt-form v-if="show && !simple" :required="true" :schema="schema.profile" />

      <v-flex xs12>
        <v-layout row wrap>
          <v-flex v-if="!simple" pr-2 xs6>
            <w-schema :model="schema.profile.homeNumber">
              <v-text-field name="homeNumber" label="Numer budynku *" />
            </w-schema>
          </v-flex>

          <v-flex v-if="!simple" pl-2 xs6>
            <w-schema :model="schema.profile.localNumber">
              <v-text-field name="localNumber" label="Numer lokalu" />
            </w-schema>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-if="!simple" xs12>
        <w-schema :model="schema.profile.postalCode">
          <v-text-field name="postalCode" label="Kod pocztowy *" />
        </w-schema>
      </v-flex>

      <v-flex v-if="!simple">
        <w-schema :model="schema.profile.confirmReason">
          <v-select item-text="text" item-value="value" label="Powód akceptacji *" :items="list" />
        </w-schema>
      </v-flex>

      <v-flex v-if="!simple" xs12>
        <w-schema :model="schema.profile.confirmReasonDescription">
          <v-textarea name="confirmReasonDescription" label="Powód akceptacji - dodatkowe informacje" />
        </w-schema>
      </v-flex>
    </v-layout>

    <span class="caption grey--text">* - Pole wymagane</span>
  </div>
</template>

<script>
import { Gender, GenderTranslation, ProfileType } from '@witkac/kartamiejska-shared';
import { WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import SingleImage from '@/components/forms/SingleImage';
import TerytForm from '@/components/forms/TERYTForm';

// @vuese
// Formularz dodawnia/edycji profilu klienta
// @group Client-Profile
export default {
  components: {
    WSchema,
    TerytForm,
    SingleImage
  },
  props: {
    // Schema
    schema: {
      type: Object,
      required: true
    },
    // Czy wyświetlić tylko wymagane pola?
    simple: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy edycja?
    edit: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy modal otwarty?
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy wyświetlić pola operatora?
    official: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy generować login na podstawie imienia i nazwiska
    loginGenerate: {
      type: Boolean,
      required: false,
      default: true
    },
    // Czy ukryć pole email
    hideEmail: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      random: ('' + Math.floor(Math.random() * 10000)).toLowerCase().padStart(4, '0'),
      ProfileType,
      gender: [
        { text: GenderTranslation[Gender.FEMALE], value: Gender.FEMALE + '' },
        { text: GenderTranslation[Gender.MALE], value: Gender.MALE + '' }
      ]
    };
  },
  computed: mapState({
    list: state => {
      const setting = state.settings.settings.PROFILE_CONFIRM_LIST;
      if (setting) {
        return JSON.parse(setting.value).list;
      }
    }
  }),
  created() {
    if (!this.simple) {
      this.$store
        .dispatch('settings/settingFind', 'PROFILE_CONFIRM_LIST')
        .catch(error => this.$store.dispatch('notifyError', { title: 'Nie udało się pobrać danych ustawień.' }));
    }
  },
  methods: {
    // @vuese
    // Wygenerowanie loginu na podstawie imienia oraz nazwiska
    generateLogin() {
      if (this.edit || !this.loginGenerate) {
        return;
      }
      const firstName = this.schema.profile.firstName.$model;
      const lastName = this.schema.profile.lastName.$model;
      if (!firstName && !lastName) {
        return;
      }
      const userName = (firstName + '-' + lastName + '-' + this.random)
        .replace(/[^a-z0-9ąćęłńóśźż]/gi, '-')
        .replace(/--+/g, '-')
        .toLowerCase();
      this.schema.login.$setData(userName);
    }
  }
};
</script>

<style>
.date-picker .v-input__prepend-outer {
  display: none;
}
</style>
